var version = "4.1.3";
export { version as default };
//# sourceMappingURL=Version.js.map
